const selectLang = {
  /** Outer wrapper: scrollable list + fixed footer (mobile multi-lang). */
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: { xs: 'min(88dvh, 100%)', md: 'min(78vh, 680px)' },
    overflow: 'hidden',
    bgcolor: 'white',
  },
 boxContainer: { 
    mx: 'auto', 
    bgcolor: 'white', 
    mt:'0 !important',
    padding: '1rem 1rem 0.5rem 1rem',
    width: {
      xs: '100%', 
      md: '560px', 
    },
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
 },
 dialogHeading: {
   fontSize: '18px', 
   fontWeight: 600, 
   color: '#111111', 
   lineHeight: '150%',
 },
 dialogSubHeading: {
   fontSize: '14px', 
   lineHeight: '150%', 
   color: '#6C6C6C',
   paddingBottom: '0.5rem'
 },
  proceedButton: (primaryColor) => ({
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '24px',
    padding: '12px 16px',
    borderRadius: '8px',
    width: {
      xs: '100%',
      md: 'auto',
    },
    backgroundColor: primaryColor,
    '&:focus': {
      backgroundColor: primaryColor,
    },
    '&:hover': {
      backgroundColor: primaryColor,
    },
  }),
 buttonContainer: {
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'flex-end',
    padding: '1rem',
    paddingBottom: { xs: 'calc(1rem + env(safe-area-inset-bottom, 0px))', md: '1rem' },
    borderTop: '1px solid #D9D9D9',
    backgroundColor: '#fff',
    justifyContent: {
      xs: 'center', 
      md: 'flex-end', 
    },
 },
 closeIcon: {
   cursor: 'pointer', 
   fontSize: '18px', 
   fontWeight: 600, 
   color: '#1C1B1F', 
   lineHeight: '150%',
 },
  selectLang: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    mr: 0,
    ml: 0,
    borderRadius: '8px',
    '& .MuiFormControlLabel-label': {
      fontSize: '1rem',
      fontWeight: 400,
      textAlign: 'left',
      pl: '0.5rem',
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
    },
  },
  radio: {
    color: '#d0d0d0',
  }

};
export default selectLang;
